export const normalizeBooleanLike = (value: unknown): boolean =>
    value === true ||
    value === 'true' ||
    value === 1 ||
    value === '1';
